"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IconContext: function() {
        return IconContext;
    },
    IconProvider: function() {
        return IconProvider;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _material = /*#__PURE__*/ _interop_require_default(require("./material"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const IconContext = /*#__PURE__*/ _react.default.createContext({
    icons: [],
    filteredIcon: (_s)=>{
        throw new Error("filterIcon not implemented.");
    }
});
const IconProvider = (param)=>{
    let { children } = param;
    const icons = (0, _react.useMemo)(()=>_material.default.icons.map((icon)=>({
                name: icon.name,
                human: "".concat(icon.name.charAt(0).toUpperCase()).concat(icon.name.slice(1)).split("_").join(" "),
                tags: icon.tags
            })), []);
    const filteredIcon = (0, _react.useCallback)((search)=>{
        return search === "" ? icons : icons.filter((i)=>i.name.startsWith(search) || i.tags.filter((tag)=>tag.startsWith(search)).length > 0);
    }, [
        icons
    ]);
    return /*#__PURE__*/ _react.default.createElement(IconContext.Provider, {
        value: {
            icons,
            filteredIcon
        }
    }, children);
};

//# sourceMappingURL=IconProvider.js.map